import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./BusRatesTable.css";

const Buanewtable = () => {

  const ratesData = [

    {
      vehicle: "Swift Dzire",
      type: "Sedan",
      image: "/images/fleet/Swift-Dzire.png",
      seater: "4+1",
      luggage: "2 Bags",
      perKm: "₹12",
      whatsapp: "919545731161",
    },

    // {
    //   vehicle: "Hyundai Aura",
    //   type: "Sedan",
    //   image: "/images/fleet/Hyundai-Aura.png",
    //   seater: "4+1",
    //   luggage: "2 Bags",
    //   perKm: "₹12",
    //   whatsapp: "919545731161",
    // },

    // {
    //   vehicle: "Toyota Etios",
    //   type: "Sedan",
    //   image: "/images/fleet/Toyota-Etios.png",
    //   seater: "4+1",
    //   luggage: "2 Bags",
    //   perKm: "₹14",
    //   whatsapp: "919545731161",
    // },

    {
      vehicle: "Maruti Ertiga",
      type: "MPV",
      image: "/images/fleet/Maruti-Ertiga.png",
      seater: "6+1",
      luggage: "4 Bags",
      perKm: "₹15",
      whatsapp: "919545731161",
    },

    {
      vehicle: "Kia Carens",
      type: "Premium MPV",
      image: "/images/fleet/Kia-Carens.png",
      seater: "6+1",
      luggage: "4 Bags",
      perKm: "₹17",
      whatsapp: "919545731161",
    },

    {
      vehicle: "Innova Crysta",
      type: "Luxury SUV",
      image: "/images/fleet/Innova-Crysta.png",
      seater: "7+1",
      luggage: "5 Bags",
      perKm: "₹20",
      whatsapp: "919545731161",
    },

    {
      vehicle: "Tempo Traveller",
      type: "Traveller",
      image: "/images/fleet/Tempo-Traveller.png",
      seater: "13-17",
      luggage: "12 Bags",
      perKm: "On Call",
      whatsapp: "919545731161",
    },

    {
      vehicle: "Urbania",
      type: "Luxury Traveller",
      image: "/images/fleet/Urbania-Bus.png",
      seater: "17",
      luggage: "14 Bags",
      perKm: "On Call",
      whatsapp: "919545731161",
    },

    {
      vehicle: "Mini Bus",
      type: "Bus",
      image: "/images/fleet/Mini-Bus.png",
      seater: "20-32",
      luggage: "20 Bags",
      perKm: "On Call",
      whatsapp: "919545731161",
    }

  ];

  const handleBooking = (vehicle, number) => {

    const message =
      `Hello Mumbai Airport Cabs, I want to book ${vehicle}. Please share details.`;

    window.open(
      `https://wa.me/${number}?text=${encodeURIComponent(message)}`,
      "_blank"
    );

  };

  return (

    <section className="fleet-wrapper">

      <div className="container">

        <div className="fleet-heading">

          <span>Premium Fleet</span>

          <h2>Choose Your Vehicle</h2>

          <p>
            Airport Transfer • Local • Outstation • Corporate
          </p>

        </div>

        <div className="fleet-list">
            
            {ratesData.map((car, index) => (
  <div className="fleet-item" key={index}>

    {/* Vehicle Image */}

    <div className="fleet-image">

      <img src={car.image} alt={car.vehicle} />

    </div>

    {/* Details */}

    <div className="fleet-details">

      <div className="fleet-top">

        <div>

          <h3>{car.vehicle}</h3>

          <span className="vehicle-type">
            {car.type}
          </span>

        </div>

        <div className="price-box">

          <small>Starting From</small>

          <h4>{car.perKm}</h4>

          <span>/ KM</span>

        </div>

      </div>

    

      <div className="feature-list">

        <span>
          <i className="fas fa-users"></i>
          {car.seater}
        </span>

        <span>
          <i className="fas fa-suitcase"></i>
          {car.luggage}
        </span>

        <span>
          <i className="fas fa-snowflake"></i>
          AC
        </span>

        <span>
          <i className="fas fa-map-marker-alt"></i>
          Airport
        </span>

        <span>
          <i className="fas fa-route"></i>
          Outstation
        </span>

        <span>
          <i className="fas fa-user-tie"></i>
          Driver
        </span>

      </div>

    </div>

    {/* Booking */}

    <div className="fleet-book">

     
      <button
        onClick={() =>
          handleBooking(
            car.vehicle,
            car.whatsapp
          )
        }
      >
        <i className="fab fa-whatsapp"></i>

        Book Now
      </button>

    </div>

  </div>
))}
        </div>

      </div>

    </section>

  );

};

export default Buanewtable;